exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search_criteria[data-v-031b73a6]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:10px}.search_criteria>div[data-v-031b73a6]{margin:0 5px;width:180px}.page_box[data-v-031b73a6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.page_box[data-v-031b73a6]  .el-pagination__jump{margin-left:0px}", ""]);

// exports
